import chatBots from '../settings/chatBots/chatBots.route';
import automationFlows from '../settings/automationFlows/automationFlows.routes';
import canned from '../settings/canned/canned.routes';
import scheduledMessages from '../settings/scheduled-messages/scheduled-messages.routes';

export default {
  routes: [
    ...chatBots.routes,
    ...automationFlows.routes,
    ...canned.routes,
    ...scheduledMessages.routes,
  ],
};
